(() => {
  function init() {
    document.querySelectorAll('video[data-morris-demo]').forEach(video => {
      if (video.dataset.demoReady) return;
      video.dataset.demoReady = 'true';
      let pausedByUser = false, pausing = false;
      video.addEventListener('pause', () => { if (!pausing && !video.ended) pausedByUser = true; });
      video.addEventListener('play', () => { pausedByUser = false; });
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !reduced.matches && !pausedByUser && !document.hidden) video.play().catch(() => {});
          else if (!entry.isIntersecting && !video.paused) {
            pausing = true; video.pause(); setTimeout(() => { pausing = false; }, 0);
          }
        });
      }, { threshold: 0.6 });
      observer.observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) { pausing = true; video.pause(); setTimeout(() => { pausing = false; }, 0); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
